const UserList = () => import('@/vuepage/user-manage/user-manage/UserList');
const UserDetail = () => import('@/vuepage/user-manage/user-manage/UserDetail');
const CompanyList = () => import('@/vuepage/user-manage/company-manage/CompanyList');
const MemberList = () => import('@/vuepage/user-manage/member-manage/MemberList');
const MemberDetail = () => import('@/vuepage/user-manage/member-manage/MemberDetail');
const MemberSetting = () => import('@/vuepage/user-manage/member-manage/MemberSetting');
const MemberSettingDialog = () => import('@/vuepage/user-manage/member-manage/MemberSettingDialog');

export default [{
		path: '/user-list',
		component: UserList,
		meta: [{
				name: '用户管理'
			},
			{
				name: '用户列表',
				activeRoute: '/user-list'
			}
		]
	},
	{
		path: '/user-detail',
		component: UserDetail,
		meta: [{
				name: '用户管理'
			},
			{
				name: '用户列表',
				url: '/user-list'
			},
			{
				name: '用户详情',
				activeRoute: '/user-detail'
			}
		]
	},
	{
		path: '/company-list',
		component: CompanyList,
		meta: [{
				name: '用户管理'
			},
			{
				name: '企业管理',
				activeRoute: '/company-list'
			}
		]
	},
	{
		path: '/member-list',
		component: MemberList,
		meta: [{
				name: '会员管理'
			},
			{
				name: '付费会员列表',
				activeRoute: '/member-list'
			}
		]
	},
	{
		path: '/member-detail',
		component: MemberDetail,
		meta: [{
				name: '会员管理'
			},
			{
				name: '付费会员列表',
				url: '/member-list'
			},
			{
				name: '会员详情',
				activeRoute: '/member-detail'
			}
		]
	},
	{
		path: '/member-setting',
		component: MemberSetting,
		meta: [{
				name: '会员管理'
			},
			{
				name: '会员配置',
				url: '/member-setting'
			},
		]
	},
	{
		path: '/member-setting-dialog',
		component: MemberSettingDialog,
		meta: [{
				name: '会员管理'
			},
			{
				name: '会员配置',
				url: '/member-setting'
			},
			{
				name: '新增/编辑付费会员',
				activeRoute: '/member-setting-dialog'
			}
		]
	},
];